import assigneeFilter from './assigneeFilter';
import tagFilter from './tagFilter';
import dateCreatedFilter from '../shared/dateCreatedFilter';
import pipelineStageFilter from './pipelineStageFilter';
import contactListFilter from './contactListFilter';

export default (accountId) => {
  if (!accountId) {
    return [];
  }

  return [
    assigneeFilter(accountId),
    tagFilter(accountId),
    pipelineStageFilter(accountId),
    contactListFilter(accountId),
    dateCreatedFilter,
  ].filter(Boolean);
};
